import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// *** componentes ***  //
import Header from "../Components/Header";
import Footer from "../Components/Footer";

// *** vistas ***  //
// import Cursos from "../Views/Cursos";
import Premiaciones from "../Views/Premiaciones";
import Error from "../Views/Error";

const Routers = () => (
  <BrowserRouter>
    <Header />

    <Routes>
      {/* vistas */}
      <Route exact path="/" element={<Premiaciones />} />
      {/* <Route exact path="/cursos" element={<Cursos />} /> */}

      {/* otras */}
      <Route path="/*" element={<Error />} />
    </Routes>

    <Footer />
  </BrowserRouter>
);

export default Routers;
